import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";

export default function RelatedList({ items }: { items: ContentItem[] }) {
  if (items.length === 0) return null;
  return (
    <div>
      <h2 className="font-heading text-lg md:text-xl font-black text-foreground-950 mb-4 flex items-center gap-2">
        <span className="w-1.5 h-6 rounded-full bg-primary-500" />
        相关推荐
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex gap-3 rounded-xl bg-background-50 border border-background-200 p-3 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <div className="w-24 h-16 shrink-0 rounded-lg overflow-hidden">
              <img
                src={item.cover}
                alt={item.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="min-w-0">
              <h3 className="text-sm font-medium text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-400 mt-1 flex items-center gap-1">
                <i className="ri-calendar-line" /> {item.date}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}